export default {
  result: 'SUCCESS',
  uwmeSubmitResult: [
    // {
    //   status: 'fulfilled',
    //   deductible: '',
    //   value: {
    //     result: 'SUCCESS',
    //     payLoad: {
    //       quotationId: 83194,
    //       enquireKey: '6b7f61be6fc8bac4fb085bce83e3567e5bccec2d',
    //       payLoad: {
    //         policySettingDto: {
    //           policyRefNo: 'EP176974',
    //           productCode: 'epfci',
    //           planCode: 'BAS',
    //           languagePreference: 'EN'
    //         },
    //         insuredPersonList: [
    //           {
    //             fullName: 'sample name 1',
    //             idNumber: 'aaaaaabbcccc',
    //             idType: 'ID',
    //             gender: 'M',
    //             dob: '11-11-1990',
    //             addressDtoList: [
    //               {
    //                 addressType: 'R',
    //                 address1: 'ADD1',
    //                 address2: 'ADD2',
    //                 address3: 'ADD3',
    //                 address4: 'SUNGAI BULOH',
    //                 address5: 'SELANGOR DARUL EHSAN',
    //                 fullAddress:
    //                   'SAMPLE FULL ADDRESS',
    //                 postalCode: '47000'
    //               }
    //             ],
    //             telContactDtoList: [
    //               {
    //                 telType: 'M',
    //                 telNo: '1234567890',
    //                 telCoCountryCode: '60'
    //               }
    //             ],
    //             relationshipWithApplicant: 'SE',
    //             customerSequence: 0,
    //             smoker: 'N',
    //             dailyCigaretteIntake: 0,
    //             coverageAge: 80,
    //             sumInsuredAmount: 30000.0,
    //             underwriteMeEnquireId: '4405fbaf-0886-4263-b76b-483d1449a8c3',
    //             underwriteMeResult: 'REDUCESUM'
    //           }
    //         ],
    //         priceResultInfoDto: [
    //           {
    //             paymentFreq: 'ANNUALLY',
    //             currency: 'RM',
    //             grossPremium: 70.0,
    //             totalNetPremium: 70.0,
    //             paymentDue: 70.0
    //           },
    //           {
    //             paymentFreq: 'MONTHLY',
    //             currency: 'RM',
    //             grossPremium: 7.08,
    //             totalNetPremium: 7.08,
    //             paymentDue: 7.08
    //           }
    //         ],
    //         underwriteMeResult: 'STANDARD',
    //         sumInsuredLevel: '30000',
    //         coverageAgeLevel: '1',
    //         familyStructure: 'S'
    //       }
    //     },
    //     errorDetails: null
    //   }
    // },
    // {
    //   status: 'fulfilled',
    //   deductible: '',
    //   value: {
    //     result: 'SUCCESS',
    //     payLoad: {
    //       quotationId: 83194,
    //       enquireKey: '6b7f61be6fc8bac4fb085bce83e3567e5bccec2d',
    //       payLoad: {
    //         policySettingDto: {
    //           policyRefNo: 'EP176974',
    //           productCode: 'epfci',
    //           planCode: 'BAS',
    //           languagePreference: 'EN'
    //         },
    //         insuredPersonList: [
    //           {
    //             fullName: 'sample name 2',
    //             idNumber: 'aaaaaabbcccc',
    //             idType: 'ID',
    //             gender: 'F',
    //             dob: '11-11-1992',
    //             addressDtoList: [
    //               {
    //                 addressType: 'R',
    //                 address1: 'ADD1',
    //                 address2: 'ADD2',
    //                 address3: 'ADD3',
    //                 address4: 'SUNGAI BULOH',
    //                 address5: 'SELANGOR DARUL EHSAN',
    //                 fullAddress:
    //                   'SAMPLE FULL ADDRESS',
    //                 postalCode: '47000'
    //               }
    //             ],
    //             telContactDtoList: [
    //               {
    //                 telType: 'M',
    //                 telNo: '1111111111',
    //                 telCoCountryCode: '60'
    //               }
    //             ],
    //             relationshipWithApplicant: 'SP',
    //             customerSequence: 0,
    //             smoker: 'N',
    //             dailyCigaretteIntake: 0,
    //             coverageAge: 80,
    //             sumInsuredAmount: 30000.0,
    //             underwriteMeEnquireId: '4405fbaf-0886-4263-b76b-483d1449a8c3',
    //             underwriteMeResult: 'ERROR'
    //           }
    //         ],
    //         priceResultInfoDto: [
    //           {
    //             paymentFreq: 'ANNUALLY',
    //             currency: 'RM',
    //             grossPremium: 70.0,
    //             totalNetPremium: 70.0,
    //             paymentDue: 70.0
    //           },
    //           {
    //             paymentFreq: 'MONTHLY',
    //             currency: 'RM',
    //             grossPremium: 7.08,
    //             totalNetPremium: 7.08,
    //             paymentDue: 7.08
    //           }
    //         ],
    //         underwriteMeResult: 'STANDARD',
    //         sumInsuredLevel: '30000',
    //         coverageAgeLevel: '1',
    //         familyStructure: 'S'
    //       }
    //     },
    //     errorDetails: null
    //   }
    // },
    // {
    //   status: 'fulfilled',
    //   deductible: '',
    //   value: {
    //     result: 'SUCCESS',
    //     payLoad: {
    //       quotationId: 83194,
    //       enquireKey: '6b7f61be6fc8bac4fb085bce83e3567e5bccec2d',
    //       payLoad: {
    //         policySettingDto: {
    //           policyRefNo: 'EP176974',
    //           productCode: 'epfci',
    //           planCode: 'BAS',
    //           languagePreference: 'EN'
    //         },
    //         insuredPersonList: [
    //           {
    //             fullName: 'sample name 3',
    //             idNumber: 'aaaaaabbcccc',
    //             idType: 'ID',
    //             gender: 'M',
    //             dob: '11-11-2012',
    //             addressDtoList: [
    //               {
    //                 addressType: 'R',
    //                 address1: 'NO. 465',
    //                 address2: 'KG LUAGAN',
    //                 address3: '',
    //                 address4: 'SUNGAI BULOH',
    //                 address5: 'SELANGOR DARUL EHSAN',
    //                 fullAddress:
    //                   'NO. 465, KG LUAGAN, 47000, SUNGAI BULOH SELANGOR DARUL EHSAN',
    //                 postalCode: '47000'
    //               }
    //             ],
    //             telContactDtoList: [
    //               {
    //                 telType: 'M',
    //                 telNo: '1111111111',
    //                 telCoCountryCode: '60'
    //               }
    //             ],
    //             relationshipWithApplicant: 'CH',
    //             customerSequence: 0,
    //             smoker: 'N',
    //             dailyCigaretteIntake: 0,
    //             coverageAge: 80,
    //             sumInsuredAmount: 30000.0,
    //             underwriteMeEnquireId: '4405fbaf-0886-4263-b76b-483d1449a8c3',
    //             underwriteMeResult: 'STANDARD'
    //           }
    //         ],
    //         priceResultInfoDto: [
    //           {
    //             paymentFreq: 'ANNUALLY',
    //             currency: 'RM',
    //             grossPremium: 70.0,
    //             totalNetPremium: 70.0,
    //             paymentDue: 70.0
    //           },
    //           {
    //             paymentFreq: 'MONTHLY',
    //             currency: 'RM',
    //             grossPremium: 7.08,
    //             totalNetPremium: 7.08,
    //             paymentDue: 7.08
    //           }
    //         ],
    //         underwriteMeResult: 'STANDARD',
    //         sumInsuredLevel: '30000',
    //         coverageAgeLevel: '1',
    //         familyStructure: 'S'
    //       }
    //     },
    //     errorDetails: null
    //   }
    //   }
  ],
  payLoad: [
    // {
    //   referenceNo: 'E0215483',
    //   commencementDate: null,
    //   lastDueDate: 'Oct 10, 2040',
    //   contribution: '327.00/annually',
    //   discountContribution: null,
    //   paymentTerm: 19,
    //   gracePeriod: null,
    //   policyStatus: 'PENDING',
    //   paymentStatus: null,
    //   custList: [
    //     {
    //       name: 'SAMPLE NAME',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 43,
    //       term: 19,
    //       order: '1',
    //       gender: 'F',
    //       dob: '11-11-1999',
    //       relationshipWithApplicant: 'SE',
    //       smokingInd: 'N',
    //       height: 60.0,
    //       weight: null
    //     }
    //   ],
    //   productCode: 'termLife',
    //   planCode: 'BAS',
    //   riderSumInsured: 0,
    //   specialoffer: null,
    //   firstPaymentDate: null,
    //   quotationId: 77208,
    //   enquireKey: '2d2e288d8e5301b30e15dcb2e3cb7d28c7bbfdac'
    // },
    // {
    //   referenceNo: 'E0236846',
    //   commencementDate: null,
    //   lastDueDate: null,
    //   contribution: null,
    //   discountContribution: null,
    //   paymentTerm: 20,
    //   gracePeriod: null,
    //   policyStatus: 'NEW',
    //   paymentStatus: null,
    //   custList: [
    //     {
    //       name: 'MAIN',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 38,
    //       term: 20,
    //       order: '1',
    //       gender: 'M',
    //       dob: '22-03-2005',
    //       relationshipWithApplicant: 'SE',
    //       smokingInd: 'N',
    //       height: null,
    //       weight: null
    //     },
    //     {
    //       name: 'SPOUSE',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 38,
    //       term: 20,
    //       order: '2',
    //       gender: 'F',
    //       dob: '22-03-2005',
    //       relationshipWithApplicant: 'SP',
    //       smokingInd: 'N',
    //       height: null,
    //       weight: null
    //     }
    //   ],
    //   productCode: 'termLife',
    //   planCode: 'BAS',
    //   riderSumInsured: 0,
    //   specialoffer: null,
    //   firstPaymentDate: null,
    //   quotationId: 82341,
    //   enquireKey: '48e8999cca3f49e775da13cd653e501b1ffde7dc'
    // },
    // {
    //   referenceNo: 'E0236870',
    //   commencementDate: null,
    //   lastDueDate: null,
    //   contribution: null,
    //   discountContribution: null,
    //   paymentTerm: 20,
    //   gracePeriod: null,
    //   policyStatus: 'NEW',
    //   paymentStatus: null,
    //   custList: [
    //     {
    //       name: 'MAIN',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 38,
    //       term: 20,
    //       order: '1',
    //       gender: 'M',
    //       dob: '11-11-1990',
    //       relationshipWithApplicant: 'SE',
    //       smokingInd: 'N',
    //       height: null,
    //       weight: null
    //     },
    //     {
    //       name: 'WIFE',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 38,
    //       term: 20,
    //       order: '2',
    //       gender: 'F',
    //       dob: '11-11-1992',
    //       relationshipWithApplicant: 'SP',
    //       smokingInd: 'N',
    //       height: null,
    //       weight: null
    //     },
    //     {
    //       name: 'CHILD',
    //       nRIC: 'aaaaaa-bb-XXXX',
    //       sumCoverage: 300000.0,
    //       upToAge: 22,
    //       term: 20,
    //       order: '3',
    //       gender: 'M',
    //       dob: '11-11-2012',
    //       relationshipWithApplicant: 'CH',
    //       smokingInd: 'N',
    //       height: null,
    //       weight: null
    //     }
    //   ],
    //   productCode: 'termLife',
    //   planCode: 'BAS',
    //   riderSumInsured: 0,
    //   specialoffer: null,
    //   firstPaymentDate: null,
    //   quotationId: 82350,
    //   enquireKey: 'aebeff1731204fdb877653322561947e41adf1b7'
    // }
  ],
  errorDetails: null
};

// export default {
//   payLoad: {
//     policySettingDto: {
//       policyRefNo: 'E0004594',
//       productCode: 'termLife',
//       planCode: 'BAS',
//       languagePreference: 'EN',
//       additionalCoverageDtoList: [
//         { productCode: 'accidMedR', planCode: 'BAS', sumInsuredAmount: 2000 }
//       ]
//     },
//     insuredPersonList: [
//       {
//         fullName: 'SAMPLE',
//         idNumber: 'aaaaaa-bb-cccc',
//         idType: 'ID',
//         gender: 'M',
//         dob: '03-02-2001',
//         addressDtoList: [
//           {
//             addressType: 'R',
//             address1: 'ADD1',
//             address2: 'ADD2',
//             address3: 'ADD3',
//             address4: 'BATU GAJAH',
//             address5: 'PERAK',
//             postalCode: '31000',
//             countryCode: 'MY'
//           },
//           {
//             addressType: 'C',
//             address1: 'ADD1',
//             address2: 'ADD2',
//             address3: 'ADD3',
//             address4: 'BATU GAJAH',
//             address5: 'PERAK',
//             postalCode: '31000',
//             countryCode: 'MY'
//           }
//         ],
//         email: 'chanhungchi@fwd.com',
//         telContactDtoList: [
//           {
//             telType: 'M',
//             telNo: '1111111111',
//             telCoCountryCode: '60'
//           }
//         ],
//         relationshipWithApplicant: 'SE',
//         customerSequence: 0,
//         height: 176.0,
//         weight: 67.0,
//         smoker: 'N',
//         dailyCigaretteIntake: 0,
//         coverageAge: 40,
//         sumInsuredAmount: 300000.0,
//         underwriteMeEnquireId: '162c3f08-6fdf-404b-89f8-21e035011c68',
//         underwriteMeResult: 'STANDARD'
//       }
//     ],
//     priceResultInfoDto: [
//       {
//         paymentFreq: 'ANNUALLY',
//         currency: 'RM',
//         grossPremium: 447.0,
//         totalNetPremium: 447.0,
//         paymentDue: 447.0
//       },
//       {
//         paymentFreq: 'MONTHLY',
//         currency: 'RM',
//         grossPremium: 37.25,
//         totalNetPremium: 37.25,
//         paymentDue: 37.25
//       }
//     ],
//     underwriteMeResult: 'STANDARD',
//     sumInsuredLevel: '300000',
//     coverageAgeLevel: '20',
//     familyStructure: 'S'
//   },
//   quotationId: 2065,
//   enquireKey: 'd6bd8a83ea77e4bd0bd42ad28938425e1f5d81d9'
// };
